import script from "./new-bridge.vue?vue&type=script&setup=true&lang=js"
export * from "./new-bridge.vue?vue&type=script&setup=true&lang=js"

import "./new-bridge.vue?vue&type=style&index=0&id=5a160a16&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a160a16"]])

export default __exports__